import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import OrganizationService from "../../services/organization.service";


export const getOrganization = createAsyncThunk(
  "organization/getOrganization",
  async (item, thunkAPI) => {
    try {
      const response = await OrganizationService.getOrganization(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addOrganization = createAsyncThunk(
  "organization/addOrganization",
  async (data, thunkAPI) => {
    try {
      const response = await OrganizationService.addOrganization(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateOrganization = createAsyncThunk(
  "organization/updateOrganization",
  async (payload, thunkAPI) => {
    try {
      const response = await OrganizationService.editOrganization(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteOrganization = createAsyncThunk(
  "organization/deleteOrganization",
  async (id, thunkAPI) => {
    try {
      await OrganizationService.deleteOrganization(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  organizationlist: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get organization ---------- */
      .addCase(getOrganization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrganization.fulfilled, (state, action) => {
        state.loading = false;
        state.organizationlist = action.payload?.data || [];
      })

      .addCase(getOrganization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add organization ---------- */
    //   .addCase(addOrganization.pending, (state) => {
    //     state.loading = true;
    //     state.error = null;
    //   })
    //   .addCase(addOrganization.fulfilled, (state, action) => {
    //     state.loading = false;
    //     const newOrganization = action.payload?.data || action.payload?.data || action.payload;
    //     if (newOrganization) {
    //       state.amenitylist.unshift(newOrganization);
    //     }
    //   })
    //   .addCase(addOrganization.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.payload;
    //   })


      /* ---------- Update organization ---------- */
      // .addCase(updateAmenity.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      //   state.updateSuccess = false;
      // })
      // .addCase(updateAmenity.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.updateSuccess = true;

      //   const updated = action.payload?.data;
      //   if (updated?._id) {
      //     const index = state.amenitylist.findIndex(
      //       (n) => n._id === updated._id
      //     );
      //     if (index !== -1) {
      //       state.noticeList[index] = updated;
      //     }
      //   }
      // })
      // .addCase(updateAmenity.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })

      /* ---------- Delete organization ---------- */
      // .addCase(deleteAmenity.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(deleteAmenity.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.amenitylist = state.noticeList.filter(
      //     (notice) => notice._id !== action.payload
      //   );
      // })
      // .addCase(deleteAmenity.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // });
  },
});

export const { resetUpdateStatus } = organizationSlice.actions;
export default organizationSlice.reducer;
